import { j as l } from "./AccesRecoveryIcon-CUPieIxT.js";
const c = () => /* @__PURE__ */ l.jsxs("svg", { viewBox: "0 0 76 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ l.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M63.887 15.707c-.232-2.448-2.343-3.27-5.01-3.508l.005-3.395-2.067-.002-.004 3.305a83 83 0 0 0-1.65.019l.005-3.327-2.065-.003-.006 3.394q-.671.014-1.315.016v-.01l-2.881.011.009 2.197 1.52-.006c.837.001 1.109.488 1.187.907l-.013 9.299c-.037.263-.192.683-.777.683.026.024-1.502-.002-1.502-.002l-.414 2.467 2.689.003c.5.002.993.01 1.476.015l-.004 3.433 2.064.003.005-3.397q.848.019 1.65.018l-.006 3.381 2.067.003.005-3.427c3.474-.195 5.907-1.066 6.213-4.328.247-2.626-.987-3.8-2.958-4.276 1.199-.608 1.95-1.682 1.777-3.473M55.19 25.31c1.4 0 5.792.298 5.795-2.267.004-2.676-4.388-2.28-5.788-2.282zm.015-10.756L55.2 18.68q.147 0 .34.004c1.412.025 4.49.08 4.494-2.06.003-2.188-2.958-2.113-4.404-2.077q-.245.007-.424.008",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ l.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M56 38.44c10.184 0 18.44-8.256 18.44-18.44S66.184 1.56 56 1.56 37.56 9.816 37.56 20 45.816 38.44 56 38.44M56 40c11.046 0 20-8.954 20-20S67.046 0 56 0 36 8.954 36 20s8.954 20 20 20",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ l.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20m.41-36.833 4.14 21.293 10.337 3.75zm-.937.667L5 28.917h.012L21.53 14.439zM34.97 29.208l-20.46-7.416-8.498 7.416 28.958-.001z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ l.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m68.47 30.805-1.178-1.022A14.88 14.88 0 0 0 70.94 20c0-3.743-1.374-7.161-3.648-9.783l1.178-1.022A16.44 16.44 0 0 1 72.5 20c0 4.133-1.52 7.91-4.03 10.805M66.805 7.53l-1.022 1.178A14.88 14.88 0 0 0 56 5.06a14.88 14.88 0 0 0-9.783 3.648L45.195 7.53A16.44 16.44 0 0 1 56 3.5c4.133 0 7.91 1.52 10.805 4.03M43.53 9.195A16.44 16.44 0 0 0 39.5 20c0 4.133 1.52 7.91 4.03 10.805l1.178-1.022A14.88 14.88 0 0 1 41.06 20c0-3.743 1.374-7.161 3.648-9.783zm1.665 23.275 1.022-1.178A14.88 14.88 0 0 0 56 34.94c3.743 0 7.161-1.374 9.783-3.648l1.022 1.178A16.44 16.44 0 0 1 56 36.5c-4.133 0-7.91-1.52-10.805-4.03",
      fill: "currentColor"
    }
  )
] });
export {
  c as W
};
